import { Extension } from '@tiptap/core';
import { Plugin, PluginKey } from '@tiptap/pm/state';

import { editorStore } from '../utils/editor.store';

export interface CursorRestoreOptions {
  editorId?: string;
  fallback?: 'start' | 'end';
}

export const CursorRestore = Extension.create<CursorRestoreOptions>({
  name: 'cursorRestore',

  addOptions() {
    return {
      editorId: undefined,
      fallback: 'end',
    };
  },

  onCreate() {
    const { fallback, editorId } = this.options;
    const { cursorPositions } = editorStore;
    if (!editorId) return;

    const saved = cursorPositions[editorId];

    if (!saved) return;

    const docSize = this.editor.state.doc.content.size;
    const from = Math.min(saved.from, docSize);
    const to = Math.min(saved.to, docSize);

    try {
      this.editor.commands.setTextSelection({ from, to });
    } catch {
      const pos = fallback === 'start' ? 0 : docSize;
      this.editor.commands.setTextSelection(pos);
    }
  },

  addProseMirrorPlugins() {
    const { editorId } = this.options;
    let debounceTimer: ReturnType<typeof setTimeout>;

    return [
      new Plugin({
        key: new PluginKey('cursorRestore'),
        view: () => ({
          update: (view) => {
            clearTimeout(debounceTimer);
            debounceTimer = setTimeout(() => {
              if (!editorId) return;

              const { from, to } = view.state.selection;
              editorStore.setCursorPosition(editorId, { from, to });
            }, 300);
          },
          destroy: () => {
            clearTimeout(debounceTimer);
          },
        }),
      }),
    ];
  },
});
